<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <base-search :searchList="$cbglSbgjjlSearch" :listQuery='listQuery' v-on:search='handleFilter' v-on:btn-event="onBtnClicked" style="display: inline-block;"></base-search>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <el-row style="height: 100%;" :gutter="8" >
        <el-col :span="4" style="height: 100%;">
          <el-card shadow="never" class="body-small" style="height: 100%;overflow:auto;">
            <basic-tree :Treedata="orgsTree" :isShowCheck="true" @handleNodeClick="handleNodeClick" @getCheckedKeys="getCheckedKeys"></basic-tree >
          </el-card>
        </el-col>
        <el-col :span="20" style="height: 100%;">
          <div class="bg-white" style="height: 100%;" id="table_box_height">
            <basic-table :tableHeight="tableHeight" :tableHeaderList="$cbglDscjTableHeader" :tableData="tableData" :listQuery="listQuery" @pagination="handleCurrentChange" @tableRowClick="tableRowClick"></basic-table >
          </div>
        </el-col>
      </el-row>
    </div>


    <!-- 添加弹窗 -->
    <general-form :FormDialog="FormDialog" :FormList="FormList" :title="addTitle" :FormData="addform"  @cancelDialog="cancelDialog" @confirmDialog="confirmDialog"></general-form>

  </div>

</template>

<script>
  import generalForm from '@/components/generalForm'//通用添加弹窗组件
  import {listToTreeSelect} from '@/utils'
  import * as login from '@/api/login'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import waves from '@/directive/waves' // 水波纹指令
  import Sticky from '@/components/Sticky'
  import elDragDialog from '@/directive/el-dragDialog'
  export default {
    name: 'hdybqygl',
    components: {
      Sticky,
      generalForm
    },
    directives: {
      waves,
      elDragDialog
    },
    data() {
      return {
        jsonData:[//table数据
          {serialNumber:1,state:'成功',taskName:'水表导入1',importType:'批量导入',fileName:'水表导入1',successRate:'100%',creatTime:'2022-8-8 09:55:51',endTime:'2022-8-9 13:56:13',fileSize:'200',projectOrganization:'',userId:'11504739',userNumber:'9839871987381',areaId:'10001',areaName:'李沧区',geographicalPosition:'青山路128号',isMountDevice:'是',isMountMap:'否',surfaceMountNum:'2',fatherNode:'',project:'青山路项目',projectCode:'300012',areaPersonNum:'000078',jurisdictionUser:'张三',concentratorName:'李沧1号集中器',concentratorAddress:'请上路128号',nowState:'正常',lastOnlineTime:'2022-8-9 16:24:10',belongsArea:'李沧区',communicationProtocol:'',programmePlatform:'远传监控平台',surfaceId:'263208',loginAccount:'532001',userName:'华德1',installAddress:'',mobilePhoneNum:'',IDCard:'',surfaceName:'测试水表1',surfaceNum:'123456789012345678',surfaceAddress:'0210032130',iemiNum:'98198273982713',typeSpecification:'DN15',communicationNum:'0',isPacking:'已报装',packingTime:'2022-8-9 16:36:08',currentReading:'1.23',dosage:0,balance:0,rechargeTime:'',surfaceType:'NB-IOT-V2表',switchState:'无阀',surchargeType:'-',chargeType:'不收费方案',consumptionCalculationMethod:'自动结算',magnification:'1',userWarning:'否',waterDepartmentCode:'hdcs',typeName:'DN15',manufacturer:'-',specifications:'-',hourFlow:'8.4',manufacturerAddress:'-',digitalDisplayDigit:'-',displayNum:'0',displayConfigure:'',remark:'',meterReadingTime:'2022-8-9 16:50:46',lastUpdateReading:'0.950',valveState:'无阀',equipmentType:'NB-IOT表',reportingCycle:'1440',signalIntensity:24,batteryState:'正常',communicationState:'正常',equipmentUseState:'使用中',salesOrderNumber:'-',orderNumber:'-',operator:'操作员韩涛',dataCorrection:'否',orderModifyTime:'',snr:9,iccId:898923134,cardType:'中国电信',dataSource:'中国电信网关',rsrp:34,pci:'-',celId:'1234',bindState:'已绑定',voltage:3.55,temperature:0,pressureValue:0,hardwareVersion:'d001-n21-v10',coverageLevel:0,acquisitionFrequency:60,imsi:12312444,encryption:'无加密',lampState:'正常',antimagneticState:'正常',noFlowAlarmTime:'无',availableFlow:'无',lastReading:0.05,isWarning:'否',warningType:'-',warningTopLimit:'-',warningLowerLimit:'-',surchargeSchemeName:'-',chargingMethod:'不计费',equipmentMaximum:'-',valveControlSupport:'否',valveControlShow:'是',meterReadingNo:'1477775',equipmentId:26320,},
        ],
        listQuery: { // 查询条件
          page: 1,
          limit: 50,
          queryType: '0',
          cxnr: '1',
          key: undefined
        },
        orgs: [], // 用户可访问到的组织列表
        orgsTree: [], // 用户可访问到的所有机构组成的树
        tableData:[],
        tableHeight:500,//表格高度
        CheckedKey:[],//选中数据的id集合
        tableChooseRow:{},//table选中数据
        FormDialog:false,//添加弹窗
        addform:{
          userNumber:'',
          userName:'',
          installAddress:'',
          surfaceNum:'',
          surfaceName:''
        },
        FormList:{//表格列
          column:[
            {columnKey:'userNumber',columnDescription:'用户编号',columnType:'text',prop:'userNumber',width:'120',placeholder:"用户编号",},
            {columnKey:'userName',columnDescription:'用户名',columnType:'text',prop:'userName',width:'120',placeholder:"用户名",},
            {columnKey:'installAddress',columnDescription:'安装地址',columnType:'text',prop:'installAddress',width:'120',placeholder:"安装地址",},
            {columnKey:'surfaceNum',columnDescription:'表编号',columnType:'text',prop:'surfaceNum',width:'120',placeholder:"表编号",},
            {columnKey:'surfaceName',columnDescription:'表名称',columnType:'text',prop:'surfaceName',width:'120',placeholder:"表名称",},
            {columnKey:'warningType',columnDescription:'告警类型',columnType:'text',prop:'warningType',width:'120',placeholder:"告警类型",},
          ],
          //校验
          rule:{
            userNumber: [{ required: true, message: "用户编号不能为空", trigger: "blur" }, ],
          }
        },
        addTitle:'添加',//添加弹窗标题
      }
    },
    watch: {
      
    },
    computed: {
      
    },
    filters: {
      
    },
    created() {

    },
    mounted() {
      this.getOrgTree()
      // 计算table高度
      this.$nextTick(()=>{
      let ele=document.getElementById("table_box_height");
      this.tableHeight=ele.offsetHeight-50
      window.addEventListener('resize', () => { 
        let ele=document.getElementById("table_box_height");
        this.tableHeight=ele.offsetHeight-50
        this.$forceUpdate()
      });
      // 计算table高度
    })
    },
    activated() {
      this.getList()
    },
    methods: {
      // 节点点击
      handleNodeClick(data) {
        console.log(data)
      },
      // 添加节点选中数据
      getCheckedKeys(data){
        console.log(data)
        this.CheckedKey = data
        var s = this.CheckedKey.length
        this.tableData = this.$store.state.tableDataSearch.slice(0,s)
      },
      // 按钮点击
      onBtnClicked: function(domId) {
        console.log('you click:' + domId)
        switch (domId) {
          case 'btnDel'://删除
            this.handleDelete(this.tableChooseRow)
            break
          case 'btnAdd'://添加
            this.FormDialog = true
            break
          default:
            break
        }
      },
      // 获取数据
      getList() {
        // login.getSubOrgs(this.listQuery).then(response => {
        //   if(response.code == '200'){
        //     this.tableData = Object.assign([], response.data)
        //   }else{
        //     this.$message({
        //       message:response.message,
        //       type:'warning'
        //     })
        //     this.tableData = []
        //   }
        // }).catch(()=>{
        //   this.tableData = []
        // })
        this.tableData = this.$store.state.tableDataSearch
      },
      // 获取树形组件数据
      getOrgTree() {
        var _this = this // 记录vuecomponent
        login.getOrgs().then(response => {
          _this.orgs = response.result.map(function(item) {
            return {
              id: item.id,
              label: item.name,
              parentId: item.parentId || null
            }
          })
          var orgstmp = JSON.parse(JSON.stringify(_this.orgs))
          _this.orgsTree = listToTreeSelect(orgstmp)
        })
      },
      // 搜索
      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      // 切换分页
      handleCurrentChange(val) {
        this.tableChooseRow = {}//重置选中项
        this.listQuery.page = val.page
        this.listQuery.limit = val.limit
        this.getList()
      },
      // 行点击
      tableRowClick(row){
        this.tableChooseRow = row
      },
      handleDelete(row) { // 多行删除
        this.tableData.splice(this.tableData.findIndex(e=>e.serialNumber === row.serialNumber),1)
      },
      // add弹窗取消
      cancelDialog(val){
        this.FormDialog = val
      },
      // add弹窗提交
      confirmDialog(){
        this.$store.state.tableDataSearch.push(this.addform)
        this.addform={
          userNumber:'',
          userName:'',
          installAddress:'',
          surfaceNum:'',
          surfaceName:''
        }
        this.FormDialog = false
      },
    },
  }

</script>

<style lang="scss" scoped>
  
</style>
